<template>
  <div>
    <b-card>
      <b-row>
        <b-col sm="3">
          <b-form-group label="Serviço">
            <input-select
              v-model="model.servico"
              placeholder="Todos"
              :options="$api.Arrays.ServicoGokei"
              :required="selectServicoRequired"
              single
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <!-- data inicial -->
        <b-col sm="3">
          <b-form-group :label="dtIniText">
            <kendo-datepicker
              v-model="model.datainicial"
              :max="dtMax"
              v-mask="'##/##/####'"
              :format="'dd/MM/yyyy'"
              :required="requiredData"
            ></kendo-datepicker>
          </b-form-group>
        </b-col>
        <!-- hora inicial -->
        <b-col sm="3">
          <b-form-group :label="hrIniText">
            <kendo-timepicker
              v-model="model.horainicial"
              v-mask="'##:##'"
              style="width: 238px; height: 36px"
              interval="30"
              :format="'HH:mm'"
              :required="requiredData"
            ></kendo-timepicker>
          </b-form-group>
        </b-col>

        <!-- data final -->
        <b-col sm="3">
          <b-form-group :label="dtFimText">
            <kendo-datepicker
              v-model="model.datafinal"
              :min="dtMin"
              :max="new Date()"
              v-mask="'##/##/####'"
              :format="'dd/MM/yyyy'"
              :required="requiredData"
            ></kendo-datepicker>
          </b-form-group>
        </b-col>
        <!-- hora final -->
        <b-col sm="3">
          <b-form-group :label="hrFimText">
            <kendo-timepicker
              v-model="model.horafinal"
              v-mask="'##:##'"
              style="width: 238px; height: 36px"
              interval="30"
              :format="'HH:mm'"
              :required="requiredData"
            ></kendo-timepicker>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Object },
    dtIniText: { type: String, default: 'Data Inicial' },
    dtFimText: { type: String, default: 'Data Final' },
    hrIniText: { type: String, default: 'Hora Inicial' },
    hrFimText: { type: String, default: 'Hora Final' },
    requiredData: { type: Boolean, default: true },
    selectServicoRequired: { type: Boolean, default: false }
  },
  data() {
    return {}
  },
  computed: {
    dtMin: function () {
      return this.model.datainicial
        ? kendo.parseDate(this.model.datainicial)
        : new Date('1970-01-01Z00:00:00:000')
    },
    dtMax: function () {
      return this.model.datafinal
        ? kendo.parseDate(this.model.datafinal)
        : new Date()
    },
    model: {
      get() {
        var obj = this.value
        return obj
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    'model.servico': val => {
      val ? (this.model.servico = val) : (this.model.servico = 0)
    }
  },

  methods: {
    refresh() {
      this.$emit('refresh')
    }
  }
}
</script>
